import { SerializedStyles } from "@emotion/react";
import React from "react";

export type HeaderPhotoOrVideoProps = {
  alt: string;
  headerSlotPosition: number;
  imageCss: SerializedStyles;
  /** Which of photoURL or posterURL/videoURL to render. */
  mediaType: "photo" | "video";
  photoURL: string;
  /** Video poster thumbnail — video only. */
  posterURL?: string;
  /** Playable video src — video only. */
  videoURL?: string;
};

/** Shared rendering for FullBleedMedia/LandscapeMedia: autoplay video, or a plain img. */
const HeaderPhotoOrVideo = ({
  alt,
  headerSlotPosition,
  imageCss,
  mediaType,
  photoURL,
  posterURL,
  videoURL,
}: HeaderPhotoOrVideoProps) =>
  mediaType === "video" && videoURL ? (
    // Background-style autoplay with controls, no crop tool.
    <video
      autoPlay
      controls
      css={imageCss}
      data-cy="mainImage"
      data-media-type={mediaType}
      data-slot-index={headerSlotPosition}
      loop
      muted
      playsInline
      poster={posterURL}
      src={videoURL}
    />
  ) : (
    <img
      alt={alt}
      css={imageCss}
      data-cy="mainImage"
      data-media-type={mediaType}
      data-slot-index={headerSlotPosition}
      src={photoURL}
    />
  );

export { HeaderPhotoOrVideo };
